import React,{useRef} from "react";
import styles from "./css/CartContainer.module.css";
import { Image,Button } from "react-bootstrap";
import { BsCaretDownFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import { GoShieldLock } from "react-icons/go";
import { GrDeliver } from "react-icons/gr";
import { FaCheck } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { AiOutlineDelete } from "react-icons/ai";
import { FaRegBookmark } from "react-icons/fa";
import { FiChevronLeft,FiChevronRight  } from "react-icons/fi";

export default function CartContainer() {
  const navigate = useNavigate();
 const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={styles.cartContainer}>
      <div className={styles.cartrow}>
        <div className={styles.cartCol1}>
          <div>
            <span style={{ fontFamily: "Inter, sans-serif", color: "#07448E" }}>
              Subtotal
            </span>
            <span
              style={{
                marginLeft: 10,
                fontSize: 28,
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                color: "#07448E",
              }}
            >
              ₹ 1,629
            </span>
          </div>

          <div className={styles.cartlist}>
            <div className={styles.cartCard}>
              <div className={styles.cartCardImg}>
                <Image
                  src={
                    "https://assets.clevelandclinic.org/transform/b9396844-4b15-42a0-953f-ce757b786a8e/massageTherapy-636218646-770x553-1_jpg"
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className={styles.cartCardContent}>
                <h4 className={styles.cartCardHeader}>Full Body Waxing</h4>
                <div className={styles.package}>
                  <BsCaretDownFill
                    className={styles.downicon}
                    color="#156508"
                  />{" "}
                  <span style={{ marginLeft: 10, color: "#2062AF" }}>
                    Package{" "}
                  </span>
                  <div className={styles.ratingCart}>
                    <FaStar color="#F79219" className={styles.staricon} />
                    <span style={{ marginLeft: 5 }}>4.83 (4.4 M bookings)</span>
                  </div>
                </div>
                <h4 className={styles.cartPrice}>₹ 1,629 </h4>

                <div className={styles.btnRow}>
                  <button style={{ borderRadius: 10, marginRight: 5 }}>
                    <AiOutlineDelete size={20} />
                  </button>
                  <button style={{ borderRadius: 10, marginRight: 5 }}>
                    <FaRegBookmark size={18} />
                  </button>
                  <button style={{ borderRadius: 10 }}>
                    See more like this
                  </button>
                </div>
                <div className={styles.btnRowMobile}>
                  <button style={{ borderRadius: 5, marginRight: 5 }}>
                    <AiOutlineDelete size={15} />
                  </button>
                  <button style={{ borderRadius: 5, marginRight: 5 }}>
                    <FaRegBookmark size={14} />
                  </button>
                  <button style={{ borderRadius: 5 }}>
                    See more like this
                  </button>
                </div>
              </div>
            </div>

            <div className={styles.cartCard}>
              <div className={styles.cartCardImg}>
                <Image
                  src={
                    "https://assets.clevelandclinic.org/transform/b9396844-4b15-42a0-953f-ce757b786a8e/massageTherapy-636218646-770x553-1_jpg"
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className={styles.cartCardContent}>
                <h4 className={styles.cartCardHeader}>Full Body Waxing</h4>
                <div className={styles.package}>
                  <BsCaretDownFill
                    className={styles.downicon}
                    color="#156508"
                  />{" "}
                  <span style={{ marginLeft: 10, color: "#2062AF" }}>
                    Package{" "}
                  </span>
                  <div className={styles.ratingCart}>
                    <FaStar color="#F79219" className={styles.staricon} />
                    <span style={{ marginLeft: 5 }}>4.83 (4.4 M bookings)</span>
                  </div>
                </div>
                <h4
                 className={styles.cartPrice}
                >
                  ₹ 1,629{" "}
                </h4>

                <div className={styles.btnRow}>
                  <button style={{ borderRadius: 10, marginRight: 5 }}>
                    <AiOutlineDelete size={20} />
                  </button>
                  <button style={{ borderRadius: 10, marginRight: 5 }}>
                    <FaRegBookmark size={18} />
                  </button>
                  <button style={{ borderRadius: 10 }}>
                    See more like this
                  </button>
                </div>
                <div className={styles.btnRowMobile}>
                  <button style={{ borderRadius: 5, marginRight: 5 }}>
                    <AiOutlineDelete size={15} />
                  </button>
                  <button style={{ borderRadius: 5, marginRight: 5 }}>
                    <FaRegBookmark size={14} />
                  </button>
                  <button style={{ borderRadius: 5 }}>
                    See more like this
                  </button>
                </div>
              </div>
            </div>

            <div className={styles.cartCard}>
              <div className={styles.cartCardImg}>
                <Image
                  src={
                    "https://assets.clevelandclinic.org/transform/b9396844-4b15-42a0-953f-ce757b786a8e/massageTherapy-636218646-770x553-1_jpg"
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className={styles.cartCardContent}>
                <h4 className={styles.cartCardHeader}>Full Body Waxing</h4>
                <div className={styles.package}>
                  <BsCaretDownFill
                    className={styles.downicon}
                    color="#156508"
                  />{" "}
                  <span style={{ marginLeft: 10, color: "#2062AF" }}>
                    Package{" "}
                  </span>
                  <div className={styles.ratingCart}>
                    <FaStar color="#F79219" className={styles.staricon} />
                    <span style={{ marginLeft: 5 }}>4.83 (4.4 M bookings)</span>
                  </div>
                </div>
                <h4
                 
                  className={styles.cartPrice}
                >
                  ₹ 1,629{" "}
                </h4>

                <div className={styles.btnRow}>
                  <button style={{ borderRadius: 10, marginRight: 5 }}>
                    <AiOutlineDelete size={20} />
                  </button>
                  <button style={{ borderRadius: 10, marginRight: 5 }}>
                    <FaRegBookmark size={18} />
                  </button>
                  <button style={{ borderRadius: 10 }}>
                    See more like this
                  </button>
                </div>
                <div className={styles.btnRowMobile}>
                  <button style={{ borderRadius: 5, marginRight: 5 }}>
                    <AiOutlineDelete size={15} />
                  </button>
                  <button style={{ borderRadius: 5, marginRight: 5 }}>
                    <FaRegBookmark size={14} />
                  </button>
                  <button style={{ borderRadius: 5 }}>
                    See more like this
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.cartCol2}>
        
          <div className={styles.cartpayment} style={{marginTop:54}}>
            <p className={styles.addGiftText}> Add Gift Card or Promo Code</p>
            <div className={styles.couponCart}>
              <input
                placeholder="Enter Code"
                style={{
                  padding: 5,
                  width: "70%",
                  borderRadius: 10,
                  fontFamily: "Inter, sans-serif",
                }}
              />
              <button
                style={{
                  width: 100,
                  borderRadius: 10,
                  border: "none",
                  background: "#66D6FF",
                  color: "#fff",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                Apply
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 10,
              }}
            >
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                Services:
              </span>
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                ₹ 1,629.00{" "}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 0,
              }}
            >
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                Delivery:
              </span>
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                ₹ 40{" "}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 3,
              }}
            >
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                Taxes:
              </span>
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                ₹ 1,629.00{" "}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 3,
              }}
            >
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                Promotion:
              </span>
              <span
                style={{ color: "#2062AF", fontFamily: "Inter, sans-serif" }}
              >
                ₹ -40{" "}
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 3,
              }}
            >
              <span
                style={{
                  color: "#2062AF",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontSize: 16,
                }}
              >
                Order Total:
              </span>
              <span
                style={{
                  color: "#2062AF",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 700,
                  fontSize: 16,
                }}
              >
                {" "}
                ₹ 1,629.00{" "}
              </span>
            </div>
            <hr style={{ color: "#66D6FF", border: "2px solid #66D6FF" }} />
            <div style={{ width: "100%", padding: 5, display: "flex" }}>
              <div className={styles.paymentSecure}>
                <GoShieldLock size={35} color="#07448E" />
                <h6
                  style={{
                    marginTop: 10,
                    color: "#07448E",
                    fontFamily: "Inter, sans-serif",
                    fontSize:12
                  }}
                >
                  Secure Payment
                </h6>
              </div>
              <div className={styles.paymentSecure}>
                <GrDeliver size={35} color="#07448E" />
                <h6
                  style={{
                    marginTop: 5,
                    color: "#07448E",
                    fontFamily: "Inter, sans-serif",
                    fontSize:12
                  }}
                >
                  On Time Service
                </h6>
              </div>
            </div>
          </div>
  <button
            className={styles.btnProceedCheckout}
            onClick={() => navigate("/Thankyou")}
          >
            Proceed to Checkout
          </button>
          <div className={styles.relativecartDetail}>
      <h5 style={{ color: "#002E6E" }}>Related Services</h5>

      {/* Arrows */}
      <div style={{ position: "relative" }}>
        <Button    
        style={{
            position: "absolute",
            left: -10,
            top: "40%",
            zIndex: 10,
            cursor: "pointer",
            borderRadius:100,
            background:"rgba(0,0,0,0.5)",
            border:"none"
          }}  onClick={() => scroll("left")} size="sm">
  <FiChevronLeft
          size={20}
        
         
        />
        </Button>
        <Button
         style={{
            position: "absolute",
            right: -10,
            top: "40%",
            zIndex: 10,
            cursor: "pointer",
             borderRadius:100,
            background:"rgba(0,0,0,0.5)",
            border:"none"
          }}
          onClick={() => scroll("right")}
          size="sm"
        >
      
        <FiChevronRight
          size={20}
         
          
        />
</Button>
        {/* Scrollable Cards */}
        <div
          className={styles.raltivecartRow}
          ref={scrollRef}
          style={{
            display: "flex",
            overflowX: "auto",
            scrollBehavior: "smooth",
            gap: "15px",
            paddingBottom: "10px",
          }}
        >
          {[...Array(4)].map((_, i) => (
            <div className={styles.relativeCard} key={i}>
              <div className={styles.relativecardImage}>
                <img
                  src="https://www.nerdwallet.com/tachyon/2021/11/GettyImages-1337284161.jpg?resize=2400%2C1440"
                  alt="Service"
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: 10,
                    objectFit: "cover",
                  }}
                />
              </div>
              <h6 style={{ marginTop: 10, fontSize: 13, color: "#002E6E" }}>
                Full Body Waxing
              </h6>
              <div style={{ display: "flex" }}>
                <BsCaretDownFill size={18} color="#156508" />
                <span style={{ color: "#2062AF", fontSize: 12, marginLeft: 2 }}>
                  Package
                </span>
                <div style={{ display: "flex", marginLeft: 10 }}>
                  <FaStar size={12} color="#F79219" />
                  <span style={{ fontSize: 12 }}>4.83</span>
                </div>
              </div>
              <div>
                <span style={{ color: "red", fontSize: 12 }}>-65%</span>
                <span
                  style={{
                    fontSize: 20,
                    marginLeft: 10,
                    fontWeight: "700",
                    color: "#2062AF",
                  }}
                >
                  ₹1,629
                </span>
              </div>
              <div>
                <span style={{ color: "#466590", fontSize: 12 }}>M.R.P: </span>
                <span
                  style={{
                    color: "#466590",
                    fontSize: 12,
                    textDecoration: "line-through",
                  }}
                >
                  ₹1,629
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>


          <div
            style={{
              width: "100%",
              border: "2px solid #66D6FF",
              marginTop: 10,
              height: 170,
              borderRadius: 10,
              padding: 10,
            }}
          >
            <h5 style={{ color: "#002E6E" }}>HC Promise</h5>

            <p style={{ color: "#2062AF" }}>
              <FaCheck color="#F79219" /> 4.5+ Rated Beauticians
            </p>
            <p style={{ color: "#2062AF" }}>
              <FaCheck color="#F79219" /> Luxury Salon Experience
            </p>
            <p style={{ color: "#2062AF" }}>
              <FaCheck color="#F79219" /> Premium Branded Products
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
